import React, { useState } from "react";
import { Menu, Box, UnstyledButton, Group, Text } from "@mantine/core";
import { IconChevronDown, IconCircleCheck } from "@tabler/icons";
import { useEvidenceInclusion } from "../../../../hooks/useEvidenceInclusion";

const ValidatedSwitch: React.FC = () => {
  const { suggested, setSuggested } = useEvidenceInclusion();
  const [opened, setOpened] = useState(false);

  const isValidatedOnly = !suggested;
  const displayText = isValidatedOnly ? "Validated only" : "All matches";

  return (
    <Menu
      shadow="md"
      radius="md"
      width={175}
      position="bottom-start"
      opened={opened}
      onChange={setOpened}
    >
      <Menu.Target>
        <UnstyledButton
          aria-label="Evidence filter"
          style={{
            height: 32,
            boxSizing: "border-box",
            border: "1px solid #E5E7EB",
            borderRadius: 8,
            padding: "0 8px",
            background: "#FFFFFF",
            width: 145,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
        >
          <Group spacing={6} noWrap>
            <IconCircleCheck size={18} color="#6B7280" />
            <Text fz={12}>{displayText}</Text>
          </Group>
          <IconChevronDown size={14} color="#6B7280" />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={() => setSuggested(true)}
          sx={{
            background: !isValidatedOnly ? "#EEF0FF" : undefined,
            "&:hover": {
              background: !isValidatedOnly ? "#E6E9FF" : undefined,
            },
          }}
        >
          <Text fz={12} fw={500}>All matches</Text>
        </Menu.Item>
        <Menu.Item
          onClick={() => setSuggested(false)}
          sx={{
            background: isValidatedOnly ? "#EEF0FF" : undefined,
            "&:hover": {
              background: isValidatedOnly ? "#E6E9FF" : undefined,
            },
          }}
        >
          <Text fz={12} fw={500}>Validated only</Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default ValidatedSwitch;
